import Component from "../abstracts/Component";

// <div class="control">
//   <div><label for="email">Email address: [*]</label>
//     <input type="text" name="email" id="email" class="error"
//      aria-invalid="true" aria-describedBy="err_2">
//   </div>
//   <span class="errtext" id="err_2">Error: Input data missing</span>
// </div>

export default class LoginFormComponent extends Component {
  get IDS() {
    return {
      forms: {
        header: "headerLoginForm",
        cart: "cartLoginForm",
        login: "LoginForm",
      },
      errors: {
        email: "emailError",
        password: "passwordError",
      },
    };
  }
  get SELECTORS() {
    return {
      headerLoginForm: this.IDS.forms.header,
      cartLoginForm: this.IDS.forms.cart,
      loginLoginForm: this.IDS.forms.login,
      emailError: `#${this.IDS.errors.email}`,
      passwordError: `#${this.IDS.errors.password}`,
      email: "input[type='email']",
      password: "input[type='password']",
    };
  }

  get ERRORS_ATTRIBUTES() {
    return {
      emailBlank: "data-error-email-blank",
      passwordBlank: "data-error-password-blank",
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  readDOM() {
    return {
      headerLoginForm: document.getElementById(this.SELECTORS.headerLoginForm),
      cartLoginForm: document.getElementById(this.SELECTORS.cartLoginForm),
      LoginForm: document.getElementById(this.SELECTORS.loginLoginForm),
      email: this.$component.querySelector(this.SELECTORS.email),
      password: this.$component.querySelector(this.SELECTORS.password),
      emailError: this.$component.querySelector(this.SELECTORS.emailError),
      passwordError: this.$component.querySelector(
        this.SELECTORS.passwordError,
      ),
    };
  }

  checkFormValidity(event) {
    const currentTarget = this.dom[event.target.id];
    let isValid = true;
    const email = this.dom[event.target.id].querySelector(this.SELECTORS.email);
    const password = this.dom[event.target.id].querySelector(
      this.SELECTORS.password,
    );
    const emailError = this.dom[event.target.id].querySelector(
      this.SELECTORS.emailError,
    );
    const passwordError = this.dom[event.target.id].querySelector(
      this.SELECTORS.passwordError,
    );

    this.MESSAGES = {
      email: {
        blank: currentTarget.getAttribute(this.ERRORS_ATTRIBUTES.emailBlank),
      },
      password: {
        blank: currentTarget.getAttribute(this.ERRORS_ATTRIBUTES.passwordBlank),
      },
    };

    if (!password.value) {
      isValid = false;
      passwordError.textContent = this.MESSAGES.password.blank;
      password.parentElement.classList.add("error");
      password.setAttribute("aria-invalid", "true");
      password.focus();
    } else {
      passwordError.textContent = "";
      password.setAttribute("aria-invalid", "false");
      password.parentElement.classList.remove("error");
    }

    if (!email.value) {
      isValid = false;
      emailError.textContent = this.MESSAGES.email.blank;
      email.parentElement.classList.add("error");
      email.setAttribute("aria-invalid", "true");
      email.focus();
    } else {
      emailError.textContent = "";
      email.setAttribute("aria-invalid", "false");
      email.parentElement.classList.remove("error");
    }

    if (!isValid) {
      event.preventDefault();
    }
  }

  addAriaAttributes(component) {
    const email = component.querySelector(this.SELECTORS.email);
    const password = component.querySelector(
      this.SELECTORS.password,
    );
    email &&
      email.setAttribute(
        "aria-describedBy",
        this.IDS.errors.email,
      );
    password &&
      password.setAttribute(
        "aria-describedBy",
        this.IDS.errors.password,
      );
  }

  bindEvents() {
    this.dom.headerLoginForm &&
      this.dom.headerLoginForm.addEventListener(
        "submit",
        this.checkFormValidity.bind(this),
      );
    this.dom.cartLoginForm &&
      this.dom.cartLoginForm.addEventListener(
        "submit",
        this.checkFormValidity.bind(this),
      );
    this.dom.LoginForm &&
      this.dom.LoginForm.addEventListener(
        "submit",
        this.checkFormValidity.bind(this),
      );
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    // this.initErrorsMessages();
    this.dom.headerLoginForm && this.addAriaAttributes(this.dom.headerLoginForm);
    this.dom.cartLoginForm && this.addAriaAttributes(this.dom.cartLoginForm);
    this.dom.LoginForm && this.addAriaAttributes(this.dom.LoginForm);
    this.bindEvents();
  }
}
